import React from 'react'
import Modal, {withModal} from 'jbc-front/components/CommonModal'
import {reduxForm} from 'redux-form'
import {FileField, RadioField, TextAreaField} from 'jbc-front/components/Form'
import Button from 'jbc-front/components/Button'
import ActionButton from 'jbc-front/components/ActionButton'
import {Upload as UploadIcon} from 'jbc-front/components/icons'
import {toBooleanProps} from 'utils'
import {getState} from 'utils'
import api from 'api'
import {asyncError} from 'store/actions/asyncError'
import styles from 'employeeFiles/Top.scss'

const formName = 'upload'

const fileTypes = [
  {value: 'true', label: '手続きファイル'},
  {value: 'false', label: '社内規定ファイル'},
]

const Form = reduxForm({
  form: formName,
  onSubmit: async (values, dispatch, {hideModal, loadData}) => {
    try {
      const state = await getState(dispatch)
      await api.createWithAuth(state.auth.token).uploadedFiles.create(values)
      hideModal()
      loadData()
    } catch (err) {
      dispatch(asyncError(err))
    }
  },
})(({handleSubmit, submitting, hideModal}) => (
  <React.Fragment>
    <Modal.Header hideModal={hideModal}>アップロードファイル選択</Modal.Header>
    <Modal.Body className={styles.modalBody}>
      <form onSubmit={handleSubmit}>
        <FileField
          name="file"
          label="ファイルアップロード"
          required
          note={
            <p>
              管理者に提出するファイルを選択してください。
              <br />
              ファイルの最大容量は10MBまでになります。
            </p>
          }
        />
        <RadioField
          name="belongs_to_procedure_status"
          label="ファイル区分"
          {...toBooleanProps}
          options={fileTypes}
          required
          note={
            <p>
              各種手続きに必要な捺印済ファイルをアップロードする場合は左を選択。
              <br />
              社内規定ファイルをアップロードする場合は右を選択。
            </p>
          }
        />
        <TextAreaField name="message_by_uploader" label="メッセージ" />
      </form>
    </Modal.Body>
    <Modal.Footer>
      <Modal.Buttons>
        <Button onClick={hideModal}>キャンセル</Button>
        <Button primary onClick={handleSubmit} disabled={submitting}>
          アップロード
        </Button>
      </Modal.Buttons>
    </Modal.Footer>
  </React.Fragment>
))

const Upload = ({isModalOpen, showModal, hideModal, loadData}) => (
  <React.Fragment>
    <ActionButton primary onClick={showModal} icon={<UploadIcon size={16} />}>
      ファイルアップロード
    </ActionButton>
    <Modal isOpen={isModalOpen} hideModal={hideModal}>
      {isModalOpen && <Form hideModal={hideModal} loadData={loadData} />}
    </Modal>
  </React.Fragment>
)

export default withModal(Upload)
